<template>
  <header id="header">
    <div class="logo is-pc">
      <router-link :to="{ name: 'home' }"><img src="/images/logo_sekisui.svg"></router-link>
    </div>

    <div class="siteName">
      <router-link :to="{ name: 'home' }" class="is-pc"><img src="/images/logo_hometechno.svg"></router-link>
      <router-link :to="{ name: 'home' }" class="is-tb"><img src="/images/logo_sekisui.svg"></router-link>
    </div>

    <div class="menuBtn" :class="{ isActive: $store.state.menu }" @click="toggleHeaderMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>

    <transition name="slide">
      <nav v-show="$store.state.menu">
        <div class="wrapper">
          <div class="bnr is-top">
            <div><a href="https://www.bathsaloon.jp/color_simulation/" target="_blank"><img src="/images/bnr-simulator.png" alt="color simulation カラーシミュレーション"></a></div>
            <div><a href="https://plan.sekisui-hometechno.co.jp/plan/index.html" target="_blank"><img src="/images/bnr-raku.png" alt="らくりえーたー"></a></div>
            <div><a href="https://sekisuihometechno.meclib.jp/SHT0100/book/" target="_blank"><img src="/images/bnr-catalog.png" alt="バスサルーン エスコート 浴室の新しいカタチ"></a></div>
            <div><a href="https://basic.archi-twin.com/showcase/model3d_public/369?token=7da88c65-ce7c-480a-a778-ef084d04cff2" target="_blank"><img src="/images/bnr-virtualshowroom.png" alt="NEW OPEN VIRTUAL SHOWROOM バーチャルショールーム"></a></div>
          </div>

          <div class="inner">
            <div class="column">
              <div>
                <ul class="gnav">
                  <mq-layout mq="tb">
                    <li @click="toggleHeaderMenu">
                      <div>
                        <span class="en">Products</span>
                        <span class="ja">製品情報</span>
                      </div>
                      <ul class="sublinks">
                        <li v-for="link in ProductLinks" :key="link.name">
                          <router-link :to="{ name: link.name }">
                            <span class="type">{{ link.type }}</span>
                            <span class="kind">{{ link.kind }}</span>
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </mq-layout>
                  <li @click="toggleHeaderMenu">
                    <router-link :to="{ name: 'concept' }">
                      <div>
                        <span class="en">Concept</span>
                        <span class="ja">コンセプト</span>
                      </div>
                    </router-link>
                  </li>
                  <li @click="toggleHeaderMenu">
                    <router-link :to="{ name: 'search' }">
                      <div>
                        <span class="en">Plan Search</span>
                        <span class="ja">プランサーチ</span>
                      </div>
                    </router-link>
                  </li>
                  <li @click="toggleHeaderMenu">
                    <router-link :to="{ name: 'feature' }">
                      <div>
                        <span class="en">Feature</span>
                        <span class="ja">機能紹介</span>
                      </div>
                    </router-link>
                  </li>
                  <li @click="toggleHeaderMenu">
                    <router-link :to="{ name: 'variation' }">
                      <div>
                        <span class="en">Color variation</span>
                        <span class="ja">カラーバリエーション</span>
                      </div>
                    </router-link>
                  </li>
                  <li>
                    <a href="https://www.sekisui-hometechno.co.jp/information/toiawase1/index.html" target="_blank">
                      <div>
                        <span class="en">Contact</span>
                        <span class="ja">お問い合わせ</span>
                      </div>
                    </a>
                  </li>
                </ul>
                <ul class="sideNav">
                  <li v-for="link in sideNavLinks" :key="link.title">
                    <a :href="link.path" target="_blank">
                      {{ link.title }}
                    </a>
                  </li>
                </ul>
                <div class="bnr is-tb">
                  <div><a href="https://www.bathsaloon.jp/color_simulation/" target="_blank"><img src="/images/bnr-simulator.png" alt="color simulation カラーシミュレーション"></a></div>
                  <div><a href="https://plan.sekisui-hometechno.co.jp/plan/index.html" target="_blank"><img src="/images/bnr-raku.png" alt="らくりえーたー"></a></div>
                  <div><a href="https://sekisuihometechno.meclib.jp/SHT0100/book/" target="_blank"><img src="/images/bnr-catalog.png" alt="バスサルーン エスコ
                  ート 浴室の新しいカタチ"></a></div>
                  <div><a href="https://basic.archi-twin.com/showcase/model3d_public/369?token=7da88c65-ce7c-480a-a778-ef084d04cff2" target="_blank"><img src="/images/bnr-virtualshowroom.png" alt="NEW OPEN VIRTUAL SHOWROOM バーチャルショールーム"></a></div>
                </div>
              </div>
              <ul class="gnav is-pc">
                <li @click="toggleHeaderMenu">
                  <div>
                    <span class="en">Products</span>
                    <span class="ja">製品情報</span>
                  </div>
                  <ul class="sublinks">
                    <li v-for="link in ProductLinks" :key="link.name">
                      <router-link :to="{ name: link.name }">
                        <span class="type">ー {{ link.type }}</span>
                        <span class="kind">{{ link.kind }}</span>
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </transition>
  </header>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      ProductLinks: [
        { name: 'wstandard', type: 'Wtype Standard', kind: 'グレード' },
        { name: 'wsimple', type: 'Wtype Simple', kind: 'グレード' },
        { name: 'wsafety', type: 'Wtype Standard Safety', kind: 'パッケージ' },
        { name: 'weasy', type: 'Wtype Standard Easy', kind: 'パッケージ' },
        { name: 'weco', type: 'Wtype Standard Eco', kind: 'パッケージ' },
        { name: 'bstandard', type: 'Btype Standard', kind: 'グレード' },
        { name: 'bsimple', type: 'Btype Simple', kind: 'グレード' },
        { name: 'blight', type: 'Btype light', kind: 'グレード' },
        { name: 'beco', type: 'Btype Standard Eco', kind: 'パッケージ' }
      ],
      sideNavLinks: [
        { path: 'https://sekisuihometechno.meclib.jp/SHT0100/book/', title: '電子カタログ' },
        { path: 'https://www.sekisui-hometechno.co.jp/company/network/index.html', title: '全国ネットワーク' },
        { path: 'https://www.sekisui-hometechno.co.jp/information/toiawase2/index.html', title: '資料請求' }
      ]
    }
  },
  methods: {
    ...mapActions(['toggleHeaderMenu'])
  }
}
</script>

<style scoped lang="scss">
header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: $headerHeight;
  padding: 0 3vw;
  background: #fff;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  z-index: 100;
}

.logo {
  margin-right: auto;

  img {
    width: 83px;
    height: 23px;
  }
}

.siteName {
  @include centering;

  img {
    width: 212px;
    height: 17px;

    @include mq(tb) {
      width: 76px;
      height: auto;
    }
  }
}

.menuBtn {
  position: relative;
  width: 32px;
  height: 23px;
  display: block;
  cursor: pointer;
  margin-left: auto;

  @include mq(tb) {
    width: 22px;
    height: 17px;
  }

  &.isActive {
    span {
      &:nth-child(1) {
        transform: translateY(7px) rotate(-45deg);
      }

      &:nth-child(2) {
        opacity: 0;
      }

      &:nth-child(3) {
        transform: translateY(-14px) rotate(45deg);

        @include mq(tb) {
          transform: translateY(-8px) rotate(45deg);
        }
      }
    }
  }

  span {
    position: absolute;
    left: 0;
    width: 100%;
    height: 2px;
    background: #000;
    transition: $fastTransition;

    &:nth-child(1) {
      top: 0;
    }

    &:nth-child(2) {
      top: 50%;
      transform: translateY(-50%);
    }

    &:nth-child(3) {
      bottom: 0;
    }
  }
}

nav {
  position: fixed;
  top: $headerHeight;
  left: 0;
  width: 100%;
  height: calc(100vh - #{ $headerHeight });
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;
  overflow: hidden;
  color: #fff;

  @include mq(tb) {
    text-align: left;
    white-space: nowrap;
  }

  .wrapper {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .inner {
    @include centering;
    text-align: center;

    @include mq(tb) {
      text-align: left;
    }
  }

  .column {
    display: flex;

    > * + * {
      margin-left: 96px;
    }
  }
}

.gnav {
  text-align: left;

  li + li {
    margin-top: 20px;

    @include mq(tb) {
      margin-top: 16px;
    }
  }

  .en {
    font-family: $bellFont;
    font-size: 27px;
    line-height: 1;
    margin-bottom: 4px;
  }

  .ja {
    font-size: 10px;
    line-height: 1;
    margin-left: 8px;
  }
}

.sublinks {
  margin-top: 12px;
  padding-left: 16px;

  @include mq(tb) {
    padding-left: 16px;
    margin-bottom: 16px;
  }

  li + li {
    margin-top: 12px;

    @include mq(tb) {
      margin-top: 4px;
    }
  }

  .type {
    font-family: $bellFont;
    font-size: 13px;
    line-height: 1;
    margin-right: 4px;
  }

  .kind {
    font-size: 10px;
    line-height: 1;
  }
}

.sideNav {
  margin-top: 16px;
  display: inline-block;

  @include mq(tb) {
    margin-top: 12px;
  }

  li {
    position: relative;
    display: inline;
    font-size: 10px;

    &:not(:last-child) {
      margin-right: 48px;

      @include mq(tb) {
        margin-right: 16px;
      }

      &::after {
        position: absolute;
        content: '/';
        top: 2px;
        right: -29px;

        @include mq(tb) {
          top: 0;
          right: -9px;
        }
      }
    }
  }
}

.bnr {
  position: absolute;
  top: 3vw;
  right: 3vw;

  @include mq(tb) {
    position: static;
    display: flex;
    margin-top: 16px;
  }

  &.is-top {
    @include mq(tb) {
      display: none;
    }
  }

  img {
    width: 180px;

    @include mq(tb) {
      width: 112px;
    }
  }

  div + div {
    margin-top: 8px;

    @include mq(tb) {
      margin-top: 0;
      margin-left: 8px;
    }
  }
}

.slide-enter-active, .slide-leave-active {
  transition: $baseTransition;
}
.slide-enter, .slide-leave-to {
  height: 0;
}
</style>
